import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const planetscale = defineConnector({
  identifier: "planetscale",
  name: "PlanetScale",
  tagLine: "Serverless MySQL platform",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: () => "https://api\\.planetscale\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.config.tokenId}:${app.secret.token}`,
      },
    ]),
  steps: [
    {
      title: "Create a service token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [PlanetScale Dashboard](https://app.planetscale.com) and go to your organization settings.\n\nUnder **Service tokens**, create a new token with the appropriate permissions for your use case.",
        },
      ],
    },
    {
      title: "Enter your service token",
      items: [
        {
          kind: "input",
          label: "Service token ID",
          placeholder: "Your service token ID",
          required: true,
          target: { kind: "configuration", field: "tokenId" },
        },
        {
          kind: "input",
          label: "Service token",
          placeholder: "pscale_tkn_...",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.planetscale.com/v1/organizations",
  },
});
